// ABOUTME: The 1A dark mask behind the duration picker: it fades in with the picker, stays through the pick, and fades over a round's first quarter.
// ABOUTME: Presentation only; the screen picks the mode from the round's phase.

import { Box } from '@mui/material';
import { keyframes } from '@emotion/react';
import { CROSSING_RESET_MASK } from '../../../../theme/crossingTokens';

const pvMaskIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;
const pvMaskOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

interface BreathMaskProps {
  mode: 'in' | 'on' | 'out' | 'fade'; // in: fades in; on: stays; out: fades out over 0.7 s; fade: fades out linearly over fadeSeconds
  fadeSeconds?: number;
  reducedMotion?: boolean;
}

export default function BreathMask({ mode, fadeSeconds = 0, reducedMotion = false }: BreathMaskProps) {
  const leaving = mode === 'out' || mode === 'fade';
  // The keyframes object is interpolated, not passed, so emotion injects its CSS when the class is built.
  const animationName = reducedMotion || mode === 'on' ? 'none' : `${mode === 'in' ? pvMaskIn : pvMaskOut}`;
  return (
    <Box
      data-testid="breath-mask"
      aria-hidden
      inert={leaving}
      sx={{
        position: 'absolute', inset: 0, zIndex: 2, background: CROSSING_RESET_MASK,
        animationName,
        animationDuration: mode === 'fade' ? `${fadeSeconds}s` : '0.7s',
        animationTimingFunction: mode === 'fade' ? 'linear' : 'ease',
        animationFillMode: 'forwards',
        pointerEvents: leaving ? 'none' : 'auto',
      }}
    />
  );
}
